import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import { PlatformConfirmDialogHost } from "./components/PlatformConfirmDialog";
import { initNativeApp } from "./lib/native-app";
import { NativeAppHost } from "./components/NativeAppHost";
import "./styles.css";

const renderApp = () => createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
      <PlatformConfirmDialogHost />
      <NativeAppHost />
    </AppErrorBoundary>
  </React.StrictMode>,
);

void initNativeApp().then(renderApp).catch(() => {
  createRoot(document.getElementById("root")!).render(
    <main className="callback-screen"><section className="callback-state error" role="alert">
      <h1>Aplikacioni nuk u hap</h1>
      <p>Ruajtja e sigurt nuk është e disponueshme. Zhblloko pajisjen dhe provo përsëri.</p>
      <button className="primary-action" onClick={() => window.location.reload()}>Provo përsëri</button>
    </section></main>,
  );
});
